import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { track } from '../analytics';

const BookACall = () => {
  const containerRef = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {
    let intervalId;
    const init = () => {
      if (window.Calendly && containerRef.current) {
        try {
          containerRef.current.innerHTML = '';
          window.Calendly.initInlineWidget({
            url: 'https://calendly.com/agcuratebv/15min?background_color=ffffff&text_color=1B2124&primary_color=2E7D32',
            parentElement: containerRef.current,
            prefill: {},
            utm: {},
          });
        } catch (_) {
          // ignore
        }
      }
    };
    if (typeof window !== 'undefined') {
      if (window.Calendly) {
        init();
      } else {
        let attempts = 0;
        intervalId = setInterval(() => {
          attempts += 1;
          if (window.Calendly) {
            clearInterval(intervalId);
            init();
          } else if (attempts > 50) {
            clearInterval(intervalId);
          }
        }, 100);
      }
    }
    return () => {
      if (intervalId) clearInterval(intervalId);
      if (containerRef.current) containerRef.current.innerHTML = '';
    };
  }, []);

  useEffect(() => {
    const handler = (e) => {
      if (e?.data?.event === 'calendly.event_scheduled') {
        track('calendly_scheduled', {
          eventType: e.data?.event,
          language: (navigator.language || 'en').toLowerCase(),
        });
      }
    };
    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }, []);

  return (
    <section id="book-a-call" className="py-20 bg-white text-dark">
      <div className="container mx-auto px-6">
        <div className="text-center mb-8">
          <h2 className="text-4xl font-bold mb-3">{t('bookCall.title')}</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            {t('bookCall.desc')}
          </p>
        </div>

        <div className="bg-white rounded-2xl p-4 md:p-6 border border-gray-200 shadow-sm">
          {/* Calendly inline widget begin */}
          <div
            ref={containerRef}
            style={{ minWidth: 320, height: 700 }}
          />
          {/* Calendly inline widget end */}
        </div>

        <div className="text-center mt-4 text-sm text-gray-500">
          <a
            href="https://calendly.com/agcuratebv?background_color=ffffff&text_color=1B2124&primary_color=2E7D32"
            target="_blank"
            rel="noreferrer"
            className="underline hover:text-primary"
            onClick={() => track('calendly_open_link')}
          >
            {t('common.openInNewTab')}
          </a>
        </div>
      </div>
    </section>
  );
};

export default BookACall;
